import { utxo } from '../utxo.js';
import { blockchairMethods } from './methods.js';
export const blockchair = (config) => utxo(config?.baseUrl || 'https://api.blockchair.com', {
    name: 'Blockchair API',
    key: 'blockchair',
    includeChainToURL: true,
    methods: {
        include: Object.keys(blockchairMethods),
    },
    ...config,
});
//# sourceMappingURL=blockchair.js.map